import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {
    addComponentAsset,
    addComponentReference, addComponentTag,
    deleteComponent, removeComponentTag, saveLoreComponent
} from "./componentsSlice";
import {Lore} from "./Lore";
import {host} from "./api";

export interface LoreState {
    lore?: Lore,
    status: Status,
    error: string | null | undefined
}

const initialState: LoreState = {
    lore: undefined,
    status: Status.Idle,
    error: null,
}

export const fetchLore = createAsyncThunk('fetchLore', async (params: { loreId: number, projectId: number }) => {
    const response = await axios.get(`${host}/lores/${params.loreId}`, {
        headers: headers(params.projectId.toString())
    })
    return response.data
})

export const loreSlice = createSlice({
    name: 'lores',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
        builder
            .addCase(fetchLore.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(fetchLore.fulfilled, (state, action) => {
                state.status = Status.Succeeded
                state.lore = action.payload
            })
            .addCase(fetchLore.rejected, (state, action) => {
                state.status = Status.Failed
                state.error = action.error.message
            })
            .addCase(saveLoreComponent.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveLoreComponent.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addComponentAsset.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addComponentAsset.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteComponent.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteComponent.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addComponentReference.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addComponentReference.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(addComponentTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(addComponentTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(removeComponentTag.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(removeComponentTag.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
    }
})

export default loreSlice.reducer;